import Vue from "vue";
import Vuex from "vuex";
import global from "@/utils/global";
import VueRouter from "@/router";
// import { useRoute, useRouter } from 'vue-router'
// import { Message } from "view-design";
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token: sessionStorage.getItem("token") || "",
        hasLogin: sessionStorage.getItem("hasLogin") || false,
        userInfo: JSON.parse(sessionStorage.getItem("userInfo")) || {},
        table: JSON.parse(sessionStorage.getItem("Table")) || {},
        isGetPk: true,

        isApp: false, // 当前环境是否为app
        platform: "", // 当前环境是android还是ios
        // userHasData:JSON.parse(sessionStorage.getItem("userHasData")) || {}
    },
    mutations: {
        loginInfo(state, obj) {
            state.hasLogin = obj.hasLogin;
            state.token = obj.token;
            state.userInfo = obj.userInfo;
            //hasOwnProperty用不了
            let falg = true;
            let bol = false;
            for (const userInfoKey in obj.userInfo.user) {
                if (userInfoKey === "customerType") {
                    falg = false;
                }
            }
            if (falg) {
                bol = true;
            }
            sessionStorage.setItem("token", obj.token);
            sessionStorage.setItem("hasLogin", obj.hasLogin);
            sessionStorage.setItem("userInfo", JSON.stringify(obj.userInfo));
            sessionStorage.setItem("isSon", bol);

            // eslint-disable-next-line no-prototype-builtins
            // state.isSon = obj.userInfo.hasOwnProperty("customerType");
            // state.isSon = obj.isSon;
        },
        clearInfo(state) {
            sessionStorage.removeItem("hasLogin");
            sessionStorage.removeItem("userInfo");
            sessionStorage.removeItem("isSon");
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("verifyPhoneList");
            state.hasLogin = false;
            state.token = "";
            state.userInfo = {};
        },
        logOut() {
            this.commit("clearInfo");
            if (global.global.ispc) {
                window.location.href = global.global.SeoUrl;
            } else {
                if (window.location.search.indexOf("out") !== -1) {
                    let u = navigator.userAgent;
                    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //安卓
                    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                    if (isAndroid) {
                        window.android.tokenExpired();
                    } else if (isIOS) {
                        window.webkit.messageHandlers.tokenExpired.postMessage("null"); //ios
                    }
                } else {
                    VueRouter.app.$router.push("/logins");
                }
            }
        },
        getTable(state, obj) {
            state.table = obj;
            sessionStorage.setItem("Table", JSON.stringify(obj));
        },
        setIsGetPkS(state, isGetPk) {
            state.isGetPk = isGetPk;
        },
        // accountInfo(state, obj) {
        //   state.userHasData = obj;
        //   sessionStorage.setItem("userHasData", JSON.stringify(obj));
        // },
    },
    actions: {
        setIsGetPk({ commit }, isGetPk) {
            commit("setIsGetPkS", isGetPk);
        },
    },
    modules: {},
});
